import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useStore } from '../../../../store';
import { ITenantPropertyForm } from '../../../../store/modules/tenants/i-tenant';
import SecondaryButton from '../../../lib/secondary-button';
import { useActions } from '../../../providers/actions-provider/actions.context';
import { DATA_MODEL_DIAGRAM_PATH, DATA_MODEL_EDIT_PATH } from '../../../routing/paths.constants';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useErd = () => {
  const { tenantActions } = useActions();
  const { push } = useHistory();
  const {
    tenantProperties,
  } = useStore();
  const columns = useMemo(() => [
    {
      title: 'Name',
      key: 'name',
      dataIndex: 'value',
    },
    {
      title: '',
      key: 'diagram',
      dataIndex: 'diagram',
      width: 50,
      render: (_:string, record: ITenantPropertyForm) => (
        <SecondaryButton
          type="button"
          className="button-edit ant-btn--small"
          onClick={() => {
            push(`${DATA_MODEL_DIAGRAM_PATH}/${record.value}`);
          }}
        >
          View Diagram
        </SecondaryButton>
      ),
    },
    {
      title: '',
      key: 'details',
      dataIndex: 'details',
      render: (_:string, record: ITenantPropertyForm) => (
        <SecondaryButton
          type="button"
          className="button-execute ant-btn--small"
          onClick={() => {
            push(`${DATA_MODEL_EDIT_PATH}/${record.value}`);
          }}
        >
          View
        </SecondaryButton>
      ),
    },
  ], []);
  return useMemo(() => ({
    onCreateProperty: (value: string) => {
      tenantActions.addProperty(`${value}`).then(() => (push(`${DATA_MODEL_EDIT_PATH}/${value}`)));
    },
    getOptions: () => {
      const options = [];
      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in tenantProperties.data) {
        options.push({ value: key });
      }
      return options;
    },
    columns,
  }), []);
};
export default useErd;
